import { render } from "./AssinaturasExport.vue?vue&type=template&id=34515724"
import script from "./AssinaturasExport.vue?vue&type=script&lang=js"
export * from "./AssinaturasExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__